/* unplugin-vue-components disabled */import script from "./notFound.vue?vue&type=script&setup=true&lang=js"
export * from "./notFound.vue?vue&type=script&setup=true&lang=js"

import "./notFound.vue?vue&type=style&index=0&id=c41497e0&scoped=true&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c41497e0"]])

export default __exports__